import React, { useState, useEffect } from 'react';
import { Bell, Megaphone, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { api } from '../lib/api';
import { PageHeader, SectionHeader, Loading, formatDate, SubscribeForm } from '../components/Shared';

const SEVERITY_CARD = {
  info: 'border-slate-200',
  warning: 'border-amber-300 bg-amber-50',
  urgent: 'border-red-300 bg-red-50',
};

export default function Alerts() {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/alerts/active').then((r) => setAlerts(r.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <Loading />;

  return (
    <div>
      <PageHeader kicker="PUBLIC ALERTS" title="Ward 8 Alerts" subtitle="Road closures, service disruptions, meeting reminders, and urgent community notices." />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 md:py-12">
        {alerts.length === 0 ? (
          <Card><CardContent className="p-8 text-center">
            <Bell className="h-10 w-10 text-slate-300 mx-auto mb-3" />
            <p className="font-bold text-[#1a2744]">No active alerts right now</p>
            <p className="text-sm text-slate-500 mt-1">Subscribe below and you'll never miss an important notice.</p>
          </CardContent></Card>
        ) : (
          <div className="space-y-4">
            {alerts.map((a) => (
              <Card key={a.id} className={SEVERITY_CARD[a.severity] || ''} data-testid="alert-card">
                <CardContent className="p-5 flex gap-3">
                  {a.severity === 'urgent' ? <AlertTriangle className="h-6 w-6 text-red-700 shrink-0" /> : <Megaphone className="h-6 w-6 text-[#1a2744] shrink-0" />}
                  <div>
                    <p className="font-serif font-bold text-[#1a2744] text-lg">{a.title}</p>
                    {a.message && <p className="text-slate-700 mt-1 leading-relaxed">{a.message}</p>}
                    <p className="text-xs text-slate-500 mt-2">Posted {formatDate(a.created_at)}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
        <div className="mt-10">
          <SectionHeader kicker="STAY INFORMED" title="Subscribe for alerts" dek="Choose the topics you care about. Unsubscribe any time." />
          <Card><CardContent className="p-5 sm:p-6"><SubscribeForm testId="alerts-subscribe-form" /></CardContent></Card>
        </div>
      </div>
    </div>
  );
}
